import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { registerAction } from '@/actions/auth';
import { winVestUpdateCustomerAction } from '@/actions/auth';
import '@/assets/styles/pages/change-password.scss';
import Tips from '../../../components/Tips/Tips';
import { tipsType } from '@/constants/tips-type';
import ChangePasswordForm from '../../../components/Authentication/ChangePassword/ChangePasswordForm';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { PATH } from '@/constants/paths';
import { SERVICES_RESP, Icons } from '@/configurations';

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTips: true,
      showFirstLoginTips: true,
    }
  }

  componentDidMount() {

  }

  toLogin = () => {
    if (iTradeEnv.thirdPartyLink) {
      window.location.href = iTradeEnv.thirdPartyLink
    } else {
      this.props.history.push(PATH.LOGIN)
    }
  }

  toHome = () => {
    this.props.history.push(PATH.TRADE)
  }

  showResultPage = () => {
    this.setState({
      showTips: false,
      showFirstLoginTips:false
    })
  }

  showFirstLoginTips = (isNeed) => {
    this.setState({
      showFirstLoginTips: isNeed
    })
  }


  render() {
    const { language } = this.props;
    const { showTips, showFirstLoginTips } = this.state;
    return (
      <React.Fragment>
        <div className='change-password-container' ref={this.containerRef}>
          <div className='panel'>
            <section className='title font-bold'>
              {language.change_password_header}
            </section>
            {
              showFirstLoginTips &&
              <Tips style={{ lineHeight: '2em', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }} type={tipsType.info} showIcon={false}>
                {language.change_password_tips}
              </Tips>
            }
            {
              showTips ?
                <ChangePasswordForm callback={() => this.showResultPage()} innerRef={e => this.changePasswordFormRef = e} showFirstLoginTips={this.showFirstLoginTips}/>
                :
                <div className={'success-change-password'}>
                    <Icons.changePasswordSuccess /> 
                  <div>{language.change_password_success}</div>
                  <div>{language.change_password_tips2}</div>
                  <section className="action_panel">
                    <button className="clear" onClick={() => this.toLogin()}>{language.common_back_login}</button>
                    <button className="submit" onClick={() => this.toHome()}>{language.common_go_directly}</button>
                  </section>
                </div>
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default withRouter(connect(
  state => ({
    language: state.app.language,
    appConfiguration: state.app.appConfiguration
  }),
  dispatch => ({
    registerAction: (p, c) => dispatch(registerAction(p, c)),
    winVestUpdateCustomer: (p, c) => dispatch(winVestUpdateCustomerAction(p, c))
  })
)(ChangePassword));
